import { render, staticRenderFns } from "./CalendarAsideHeaderTest.vue?vue&type=template&id=89eceada&scoped=true&"
import script from "./CalendarAsideHeaderTest.vue?vue&type=script&lang=js&"
export * from "./CalendarAsideHeaderTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89eceada",
  null
  
)

export default component.exports